import { render, staticRenderFns } from "./AssetsVehiclesLogsForm.vue?vue&type=template&id=69878c09&"
import script from "./AssetsVehiclesLogsForm.vue?vue&type=script&lang=js&"
export * from "./AssetsVehiclesLogsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports